module.exports = __webpack_public_path__ + "static/img/ftphoto.a345a54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ftphoto.png
// module id = 1wVK
// module chunks = 0